import { Container } from "react-bootstrap";
import CustomForm from "../components/CustomForm";
import "../assets/scss/pages/inquiry.scss";

const Inquiry = () =>  {
    return (
        <Container id="inquire" className="my-2 py-5 px-lg-5 bg-white">
            <header className="d-flex flex-column gap-3 mx-auto">
                <h3 className="text-secondary px-4">Make an Inquiry</h3>
                <p className="px-4">Kindly complete the form below to enable us better understand your needs and preferences, so we can curate the most suitable property options for you. A member of our team will reach out to you as soon as possible.</p>
            </header>
            <CustomForm
                type="full-inquiry"
            />
        </Container>
    );
};

export default Inquiry;